import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2punudte8l: FaireBrandEntity = {
  token: "b_2punudte8l",
  type: "brand",
  name: "FILLO'S",
  avatarUrl:
    "https://cdn.faire.com/fastly/1c031e0a7955cbdb82bae75c8fe5858c6c69119664f2005f1de7ca4690be439f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d0950941d10e9bf9d34b775ee258b5a8c1eff496efba8530dfa67c547365048.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1c031e0a7955cbdb82bae75c8fe5858c6c69119664f2005f1de7ca4690be439f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d0950941d10e9bf9d34b775ee258b5a8c1eff496efba8530dfa67c547365048.png",
  location: "St. Charles, IL, USA",
  minimumOrderDollars: 26,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "With Cuban and Panamanian roots, and extended family from Mexico and Puerto Rico, the Caballero brothers craved the traditional flavors they grew up with. Neither had the time to prepare meals from scratch, and nothing on the shelf came close in flavor or nutrition. Given their extensive experience in food manufacturing, they set about recreating the traditional flavors of their childhood using convenient packaging. A year later they launched FILLO’S Americas Made.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:06.295Z",
    importedBy: "entity-db-cli",
  },
};
